<template>
    <select v-model="displayValue" class="form-control" id="id_banco" >
        <option v-for="m in chips" :value="m.id" >{{ m.banco }} - {{ m.nome }}</option>
    </select>
</template>

<script>
    import {Banco} from '../../class/banco';

    export default {
        name: 'ComboContasBanco',
        props: {
            "value": {
                "default": null
            },
        },
        data(){
            return {
                chips: [],
            };
        },
        beforeMount(){
            this.loadChips();
        },
        methods: {
            async loadChips(){
                Banco
                    .combo()
                    .then((rows) => {
                        this.chips = rows;
                        this.chips.push({
                            id: null,
                            nome: "SEM COBRANCA",
                            banco: "----------"
                        });
                    })
                    .catch((err) => console.log(err));
            }
        },
        computed: {
            displayValue: {
                get() {
                    return this.value;
                },
                set(modifiedValue) {
                    this.$emit("input", modifiedValue);
                }
            }
        }
    };
</script>
